import { memo } from 'react';
import { SSkeletonBodyText } from '../../s-skeleton-body-text';
import { SSkeletonDisplayText } from '../../s-skeleton-display-text';
import styles from './SIndexTableSkeletonRows.module.css';

export const SIndexTableSkeletonRows = memo(function SIndexTableSkeletonRows({
    rowNumber,
    columnNumber,
    hasImage,
}: SIndexTableSkeletonRowsProps) {
    return (
        <>
            {Array.from({ length: rowNumber }).map((_, row) => (
                <s-table-row id={`Parent-${row}`} key={`SkeletonRow-${row}`}>
                    {Array.from({ length: columnNumber }).map((_e, i) => (
                        <s-table-cell key={`SkeletonCell-${i}}`}>
                            <div className={styles.SIndexTableSkeletonRowsCellContent}>
                                {hasImage && i === 0 ? (
                                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'nowrap' }}>
                                        <SSkeletonDisplayText
                                            height="36px"
                                            maxWidth="5ch"
                                            classNames={['shrink-0', 'basis-0', 'grow']}
                                        />
                                        <SSkeletonBodyText lines={2} minWidth="10ch" />
                                    </div>
                                ) : (
                                    <SSkeletonBodyText lines={1} minWidth="10ch" />
                                )}
                            </div>
                        </s-table-cell>
                    ))}
                </s-table-row>
            ))}
        </>
    );
});

export default SIndexTableSkeletonRows;

export interface SIndexTableSkeletonRowsProps {
    rowNumber: number;
    columnNumber: number;
    hasImage?: boolean;
}
